import Vue from 'vue'
import { PiniaVuePlugin, defineStore } from 'pinia'

Vue.use(PiniaVuePlugin);

export const userStore = defineStore('UserStore', {
    state: () => ({
        token: false,
        defaultMenu: [],
        availableMenu: [],
        user: null,
        incomingUrl: "/",
    }),
    // computed properties
    getters: {
        getToken: (state) => state.token,
        getDetailMenu: (state) => state.defaultMenu,
        getAvailableMenu: (state) => state.availableMenu,
        getUserState: (state) => state.user,
        getIncomingUrl: (state) => state.incomingUrl,
    },
    // methods
    actions: {
        tokenSet(token) {
            this.token = token;
        },

        defaultMenuSet(menu){
            this.defaultMenu = menu;
        },

        availableMenuSet(menu){
            this.availableMenu = menu;
        },

        tokenUnSet() {
            this.token = false;
            this.defaultMenu = [];
            this.availableMenu = [];
        },

        findParentFromRoute(route){
            let result = this.availableMenu.filter(menu => menu.route === route);
            return result[0];
        },

        findDefaultMenuFromParentId(parent_id){

            let result = this.availableMenu.filter(menu => menu.parent_id === parent_id);
            result.forEach(item => {
                item.text = item.name;
                item.show = true;
            });
            return result;
        },

        getActiveMenu(){
            let activeMenu = this.defaultMenu;

            return activeMenu
        },
        setUserState(state) {
            this.user = state;
        },
        unsetUserState() {
            this.user = null;
        },
        setIncomingUrl(url) {
            this.incomingUrl = url;
        },
        resetIncomingUrl() {
            this.incomingUrl = "/";
        },
    },
    persist: true,
});


